import { Grid, Skeleton, Stack } from '@mui/material';

const LoadingHome = () => {
  return (
    <Grid container spacing={0.5}>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="flex-start" gap={2} alignItems="center" ml={2}>
          <Skeleton animation="wave" variant="text" width={150} height={60} />
          <Skeleton animation="wave" variant="text" width={180} height={60} />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" variant="rectangular" height={180} sx={{ mb: 2, borderRadius: 1}} />
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent='space-between' alignItems='center' ml={2}>
          <Skeleton animation="wave" variant="text" width={200} height={24}/>
          <Stack direction="row" gap={2}>
            <Skeleton animation="wave" variant="text" width={82} height={64} />
            <Skeleton animation="wave" variant="text" width={82} height={64} />
            <Skeleton animation="wave" variant="text" width={150} height={64} />
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" variant="rectangular" height={368} sx={{ borderRadius: 1}}/>
      </Grid>
    </Grid>
  )
}

export default LoadingHome;